function aiQueryAnswerContent() {
    return (
        '<div class="ai-results-body">' +
            '<div class="ai-results-content"></div>' +
        '</div>' +
        '<div class="ai-results-footer">' +
            '<div class="ai-cta-wrapper">' +
                '<button class="ai-results-cta" type="button">' +
                    'Continue reading ' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
                        '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.5175 2.15044C9.71055 1.953 10.0271 1.94944 10.2246 2.1425L15.8496 7.6425C15.9458 7.73657 16 7.86544 16 8C16 8.13456 15.9458 8.26343 15.8496 8.3575L10.2246 13.8575C10.0271 14.0506 9.71055 14.047 9.5175 13.8496C9.32444 13.6521 9.328 13.3356 9.52544 13.1425L14.2734 8.5H0.5C0.223858 8.5 0 8.27614 0 8C0 7.72386 0.223858 7.5 0.5 7.5H14.2734L9.52544 2.8575C9.328 2.66445 9.32444 2.34789 9.5175 2.15044Z" fill="white"/>' +
                    '</svg>' +
                '</button>' +
            '</div>' +
        '</div>'
    );
}

module.exports = {
    aiQueryAnswerContent: aiQueryAnswerContent,
};
